<mat-list [formGroup]="mapListFormGroup">
  <mat-list-item>
    <mat-radio-group [disabled]="true" [formControl]="formControls.mapType">
      <mat-radio-button [value]="true"> OpenStreetmap </mat-radio-button>
      <mat-radio-button class="none" [value]="false"> Műhold </mat-radio-button>
    </mat-radio-group>
  </mat-list-item>
  <mat-list-item>
    <mat-checkbox [formControl]="formControls.showAirspace"
      >Légterek</mat-checkbox
    ></mat-list-item
  >
</mat-list>
